import { createSelector } from 'reselect';

const liveSessionManagerSelector = (state) => state.apps.manual.liveSessionManager;

// TODO: Rename metadata as capabilities!!!
const metadataSelector = (state) => (
  state.apps.manual.liveSessionManager.session.metadata
);

const isSessionReadySelector = (state) => (
  state.apps.manual.liveSessionManager.session.isReady
);

const sessionClosedBySelector = (state) => (
  state.apps.manual.liveSessionManager.session.closedPayload.closedBy
);

const isChannelReconnectionSelector = (state) => (
  state.apps.manual.liveSessionManager.channel.reconnecting
);

const sessionAppSelector = (state) => state.apps.manual.liveSessionManager.session.app;

const sessionExpiryBannerSelector = createSelector([
  (state) => state.apps.manual.liveSessionManager,
], (liveSessionManager) => ({
  secondsLeft: liveSessionManager.session.secondsLeft,
}));

const virtualSessionContainerSelector = createSelector([
  liveSessionManagerSelector,
  metadataSelector,
],
(liveSessionManager, metadata) => ({
  connectionError: liveSessionManager.session.connectionError,
  isChannelConnected: liveSessionManager.channel.isEstablished,
  isInfoLoaded: liveSessionManager.session.isInfoLoaded,
  isSessionReady: liveSessionManager.session.isReady,
  metadata,
  sessionClosedReason: liveSessionManager.session.closedPayload.reason,
}));

const virtualSessionLoadingSelector = createSelector([
  (state) => state.apps.manual.liveSessionManager.session,
],
(session) => ({
  ...session.metadata.toJS(),
  error: session.creationError,
}));

const virtualSessionSelector = createSelector([
  liveSessionManagerSelector,
  metadataSelector,
  (state) => state.user,
],
(liveSessionManager, metadata, user) => ({
  app: liveSessionManager.session.app,
  isChannelReconnecting: liveSessionManager.channel.reconnecting,
  metadata,
  owner: liveSessionManager.session.owner,
  rfbPath: liveSessionManager.channel.rfbPath,
  screenshotRetrievalInProgress: liveSessionManager.channel.screenshotRetrievalInProgress,
  user: user?.id ?? null,
}));

export default {
  isChannelReconnectionSelector,
  isSessionReadySelector,
  liveSessionManagerSelector,
  metadataSelector,
  sessionAppSelector,
  sessionClosedBySelector,
  sessionExpiryBannerSelector,
  virtualSessionContainerSelector,
  virtualSessionLoadingSelector,
  virtualSessionSelector,
};
